import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Form, Spin, Upload, Space, message } from 'antd';
import { useMutation, gql } from '@apollo/client';
import { UploadOutlined } from '@ant-design/icons';

import ErrorBoundary from '../../components/Utils/ErrorBoundary';

const EMPLOYEE_UPLOAD_FILE_QUERY = gql`
  mutation Upload($file: Upload!) {
    upload(file: $file) {
      path
      name
      mime
    }
  }
`;

const DOCUMENT_ADD_QUERY = gql`
  mutation addDocument($input: CreateDocumentInput) {
    addDocument(input: $input) {
      id
      type
      description
      media {
        id
        name
        file_name
      }
    }
  }
`;

const Document = ({
  // id,
  entityId,
  // entityType,
  // maxNumberOfFile,
  // mediaType,
  formId,
  noSubmitButtons,
  onDocumentAdd,
}) => {
  const [fileList, setFileList] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [form] = Form.useForm();

  const [
    uplodFile,
    // {
    // data: dataUpload,
    // loading: mutationUploadLoading,
    // error: mutationUploadError,
    // },
  ] = useMutation(EMPLOYEE_UPLOAD_FILE_QUERY);

  const [
    addDocument,
    // {
    // data: dataDocument,
    // loading: mutationDocumentLoading,
    // error: mutationDocumentError,
    // },
  ] = useMutation(DOCUMENT_ADD_QUERY);

  const onFileUpload = ({ onSuccess, onError, file }) => {
    console.log('onFileUpload triggered with : ', file, onSuccess, onError);
    uplodFile({
      variables: {
        file: file,
      },
    })
      .then(({ data: { upload } }) => {
        console.log('onFileUpload SUCESS////', upload);
        console.log(file);
        onSuccess(null, upload);

        addDocument({
          variables: {
            input: {
              entity_id: parseInt(entityId),
              entity_type: 'employee',
              type: 'DOC',
              description: '',
              file: {
                path: upload.path,
                name: upload.name,
                mime: upload.mime,
              },
            },
          },
        })
          .then(({ data: { addDocument: document } }) => {
            console.log('onFormSubmit ///', document);
            if (document) {
              onDocumentAdd(document);
              setFileList([]);
            }
          })
          .catch((e) => {
            console.log('mutationError ////', e, e.graphQLErrors);
            let error = 'Some error occured, Please try again !!!';
            message.error(error);
          });
      })
      .catch((e) => {
        console.log('mutationError ////', e, e.graphQLErrors);
        let error = 'Some error occured, Please try again !!!';
        message.error(error);
      });
  };

  const onFormSubmit = (values) => {
    console.log('Form submitted with ', values);
    // addDocument({
    //   variables: {
    //     input: {
    //       entity_id: parseInt(entityId),
    //       entity_type: 'employee',
    //       type: values.docType ? values.docType : 'DOC',
    //       description: values.docNumber ? values.docNumber : '',
    //       file: {
    //         path: values.file.file.xhr.path,
    //         name: values.file.file.xhr.name,
    //         mime: values.file.file.xhr.mime,
    //       },
    //     },
    //   },
    // }).then(({ data: { addDocument: document } }) => {
    //   console.log('onFormSubmit ///', document);
    //   if (document) {
    //     onDocumentAdd(document);
    //   }
    // });
  };

  const handleFileChanged = ({ file }) => {
    if (file.status === 'removed') {
      setFileList([]);
    } else if (file.status === 'uploading') {
      setUploading(true);
      setFileList([file]);
    } else if (file.status === 'done') {
      setUploading(false);
      setFileList([file]);
    }
  };

  return (
    <ErrorBoundary>
      <Form
        layout="vertical"
        className="ant-form-custom"
        form={form}
        onFinish={onFormSubmit}
        id={formId}
        style={{ marginTop: '0' }}
      >
        {/* <Form.Item
          label="Document Type"
          name="docType"
          rules={[{ required: true, message: 'Please select Document Type!' }]}
        >
          <Select placeholder="Please select">
            {[
              { key: 'Aadhar', value: 'Aadhar' },
              { key: 'DL', value: 'Driving Licence' },
              { key: 'PAN', value: 'PAN Card' },
              { key: 'Other', value: 'Others' },
            ].map((doc) => (
              <Select.Option key={doc.key} value={doc.key}>
                {doc.value}
              </Select.Option>
            ))}
          </Select>
        </Form.Item> */}
        {/* <Form.Item label="Document Description" name="docNumber">
          <Input placeholder="Document Description" />
        </Form.Item> */}
        <Form.Item
          name="file"
          rules={[{ required: true, message: 'Please select file to upload!' }]}
          style={{ marginTop: '2rem' }}
        >
          <Spin spinning={uploading}>
            <Upload
              name="file"
              fileList={fileList}
              customRequest={onFileUpload}
              onChange={handleFileChanged}
              maxCount="1"
              accept=".ppt, .pptx,application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint,text/plain, application/pdf, image/*,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            >
              <Button icon={<UploadOutlined />}>Click to upload</Button>
            </Upload>
          </Spin>
        </Form.Item>
        {!noSubmitButtons && (
          <Space>
            <Button type="secondary" size="middle" onClick={null}>
              Cancel
            </Button>
            <Button type="primary" size="middle" htmlType="submit">
              Add Employee
            </Button>
          </Space>
        )}
      </Form>
    </ErrorBoundary>
  );
};

Document.defaultProps = {
  maxNumberOfFile: 1,
  mediaType: '',
  id: null,
  formId: 'documentAddOrUpdateForm',
  noSubmitButtons: false,
};

Document.propTypes = {
  id: PropTypes.string,
  entityId: PropTypes.string.isRequired,
  entityType: PropTypes.oneOf(['employee']).isRequired,
  maxNumberOfFile: PropTypes.number,
  mediaType: PropTypes.string,
  onDocumentAdd: PropTypes.func.isRequired,
  formId: PropTypes.string,
  noSubmitButtons: PropTypes.bool,
};

export default Document;
